import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
	Wrapper,
	CategoryName,
	Trigger,
	CategoryLink,
	IconWrapper,
	HiddenCheck,
	SubCatsContainer,
	SubCats,
	SubCat,
	SectionTitle,
	AllLink,
	Caret,
} from './categoryStyles';
import { svgMap } from 'core/utils/slugMaps';

class Category extends PureComponent {
	calculateSectionHeight = (numItems, hasViewAll) => {
		const ITEM_HEIGHT = 40;
		const VIEW_ALL_HEIGHT = hasViewAll ? ITEM_HEIGHT : 0;

		const childrenHeight = numItems * ITEM_HEIGHT;
		const total = VIEW_ALL_HEIGHT  + childrenHeight;
		return `${total}px`;
	}

	getHref = (href="") => {
		if (!this.props.sidebar) return href;

		// Update tracking for sidebar
		// These tracking attributes are in Contentful...
		if (href.includes("pt=topnav")) {
			href = href.replace("pt=topnav", "pt=sidenav");
		}
		// Still catch if using the consolidated param cjt
		if (href.includes("cjt=topnav")) {
			href = href.replace("cjt=topnav", "cjt=sidenav");
		}

		return href;
	}

	render () {
		const { getHref } = this;
		const {
			sidebar, open, sectionIndex, itemIndex, titleOnly,
			long, slug, href, children,
		} = this.props;
		const SvgComponent = svgMap[slug];
		const prefix = `${sidebar ? 'sb' : ''}trigger`;
		const id = `${prefix}-${slug}`;
		const placeholderStyles = { display: 'block', width: 36, height: 32 };
		const showHeaderShopAll = !sidebar && children.find(c => Boolean(c.title)) !== undefined;
		const showNormalShopAll = !sidebar && !showHeaderShopAll;

		if (titleOnly) {
			return (
				<CategoryLink href={href ? getHref(href) : `/category/${slug}/`}>
					<CategoryName>{long}</CategoryName>
				</CategoryLink>
			);
		}

		return (
			<Wrapper>
				<HiddenCheck id={id} defaultChecked={open} />
				<Trigger htmlFor={id}>
					<CategoryLink href={href ? getHref(href) : `/category/${slug}/`}>
						{!sidebar && (<IconWrapper>
							{SvgComponent ? <SvgComponent /> : <div style={placeholderStyles} />}
						</IconWrapper>)}
						<CategoryName>{long}</CategoryName>
					</CategoryLink>
					{(!open && children.length > 0) && <Caret />}
				</Trigger>

				<SubCatsContainer sidebar={sidebar}>
					{children.map(({ title, items }, sn) => (
						title ? <Fragment key={title}>
							<HiddenCheck id={`${prefix}-${title}`} defaultChecked={open && sn === sectionIndex} />
							<Trigger htmlFor={`${prefix}-${title}`}>
								<SectionTitle>{ title }</SectionTitle>
								{items.length > 0 && <Caret fill={`#ccc`} />}
							</Trigger>
							<SubCats totalHeight={this.calculateSectionHeight(items.length, false)}>
								{items.map(({ shortName, slug, href }, index) => (
									<SubCat key={index} href={href ? getHref(href) : `/category/${slug}/`} highlight={sn === sectionIndex && index === itemIndex}>
										{ shortName }
									</SubCat>
								))}
							</SubCats>
						</Fragment> : <Fragment key={title}>
							{items.map(({ shortName, slug, href }, index) => (
								<SubCat key={index} href={href ? getHref(href) : `/category/${slug}/`} highlight={sn === sectionIndex && index === itemIndex}>
									{ shortName }
								</SubCat>
							))}
						</Fragment>
					))}
					{showHeaderShopAll && (
						<SectionTitle key={`shopAll-${id}`} as="a" href={href ? getHref(href) : `/category/${slug}/`} underline={true}>
							Shop All { long }
						</SectionTitle>
					)}
					{showNormalShopAll && <SubCat key={`shopAll-${id}`} href={href ? getHref(href) : `/category/${slug}/`} underline={true}>
						Shop All { long }
					</SubCat>}
					{!href && (
						<AllLink href={`/category/${slug}/`} title={`View All of ${long}`}>View All</AllLink>
					)}
				</SubCatsContainer>
			</Wrapper>
		);
	}

	static propTypes = {
		open: PropTypes.bool,
		sidebar: PropTypes.bool,
		sectionIndex: PropTypes.number,
		itemIndex: PropTypes.number,
		long: PropTypes.string,
		short: PropTypes.string,
		slug: PropTypes.string,
		href: PropTypes.string,
		titleOnly: PropTypes.bool,
		children: PropTypes.arrayOf(
			PropTypes.shape({
				title: PropTypes.string,
				items: PropTypes.arrayOf(
					PropTypes.shape({
						shortName: PropTypes.string,
						slug: PropTypes.string,
						href: PropTypes.string,
					})
				),
			})
		),
	}

	static defaultProps = {
		children: [],
		sectionIndex: 0, // used when `open` is true
		itemIndex: -1, // used when `open` is true
		titleOnly: false,
	}
}

export default Category;
